import { computed, type ComputedRef } from 'vue'
import { useRouter } from 'vue-router'

import { CONNECTIONS_ROUTE, useIntegrations, type AuthFamily } from '@/features/integrations'

export interface UseConnectionHealth {
  reconnectable: ComputedRef<readonly AuthFamily[]>
  contactOwner: ComputedRef<readonly AuthFamily[]>
  goToConnections: () => Promise<void>
}

export function useConnectionHealth(): UseConnectionHealth {
  const integrations = useIntegrations()
  const router = useRouter()

  const reconnectable = computed(() =>
    integrations.reauthenticationNeeded.value.filter((family) =>
      family.channelKeys.every(
        (channel) => integrations.connectableIntegrations.value?.[channel] === true,
      ),
    ),
  )
  const contactOwner = computed(() =>
    integrations.reauthenticationNeeded.value.filter(
      (family) =>
        !family.channelKeys.every(
          (channel) => integrations.connectableIntegrations.value?.[channel] === true,
        ),
    ),
  )

  return {
    reconnectable,
    contactOwner,
    goToConnections: async () => {
      await router.push(CONNECTIONS_ROUTE)
    },
  }
}
